<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>DATA SERVICES</div>
				<h2 waHeading="l" waText>Typed Angular Services from Java</h2>
				<p waBody="m" waColorText="quiet" waText>`&#64;NgDataService` generates observable data services &mdash; request or push.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<markdown [data]="mdContent_138"></markdown>
				<div class="code-block-wrapper">
					<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>&#64;NgDataService &mdash; typed server-to-client data</div>
					<markdown [data]="mdContent_139" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<markdown [data]="mdContent_140"></markdown>
			</div>
		</div>
	</div>
</div>